const routes = [
  {
    path: "/playlists",
    component: () => import("views/Playlist/Index.vue"),
    name: "playlists",
    meta: { role: ["admin", "manager"] },
  },
];

export default routes;
